import KibernetesObject from './kibernetes_utils';

const NAME_VALUTAZIONI = "KibernetesValutazioni";

class KibernetesValutazioni {
	#valutazione;
	#wrapper;
	#activeStep;
	#typeRating = '.high-rating';
	#spinner;

	constructor(options) {
		this.#init(options);
	}

	// Getters
	static get NAME() {
		return NAME_VALUTAZIONI;
	}

	// Private
	#init(options) {
		this.#wrapper = new KibernetesObject({
			selector: '.cmp-rating'
		});
		this.#activeStep = 0;
		if (!this.#wrapper) return;

		this.#spinner = kibernetes.createSpinner();

		this.#valutazione = new FormData();
		this.#valutazione.set('page', options.page);
		this.#valutazione.set('answer', options.answer);
		this.#valutazione.set('rating', options.rating);
		this.#valutazione.set('urlPageRating', options.urlPageRating);
		this.#valutazione.set('altro', options.altro);

		const radios = this.#wrapper.children('.question input');
		const stars = this.#wrapper.children('.rating input');
		const btnNext = this.#wrapper.child('.btn-next');
		const btnBack = this.#wrapper.child('.btn-back');

		stars.forEach(star => {
			star.addEventListener('change', () => {
				radios.forEach(radio => {
					radio.checked = false;
				});
				if(star.checked) {
					this.#activeStep = 0;
					this.#closeAllSteps();
					if (star.value >= 4) {
						this.#typeRating = '.high-rating';
					} else {
						this.#typeRating = '.low-rating';
					}
					this.#openNextStep();
				}
			});
		});

		if (btnNext) {
			btnNext.addEventListener('click', () => {
				this.#closePreviousStep();
				this.#openNextStep();
			});
		} 
		if (btnBack) {
			btnBack.addEventListener('click', () => {
				this.#closePreviousStep();
				this.#backToPrevious();
			});
		}
	}
	#openNextStep() {
		const stepWrapper = this.#wrapper.child("[data-step='".concat((this.#activeStep + 1),"']"));
		const typeWrapper = this.#wrapper.child(".cmp-steps-rating".concat(this.#typeRating));
		const formWrapper = this.#wrapper.child('.form-rating');
		const cardWrapper = this.#wrapper.child('.cmp-rating__card-first');
		formWrapper.show();
		stepWrapper.show( 'active' );
		typeWrapper.show( 'active' );

		this.#activeStep = this.#activeStep + 1;

		const steps = this.#wrapper.children('[data-step]');
		if ( this.#activeStep == steps.length ) {
			formWrapper.hide();
			cardWrapper.hide();

			this.#postValutazione();
		}
	}
	#backToPrevious() {
		const previousWrapper = this.#wrapper.child("[data-step='".concat((this.#activeStep - 1),"']"));
		const currentWrapper = this.#wrapper.child("[data-step='".concat(this.#activeStep,"']"));
		const formWrapper = this.#wrapper.child('.form-rating');
		const cardRating = this.#wrapper.child('.cmp-rating__card-first');
		formWrapper.show();

		this.#activeStep = this.#activeStep - 1;
		if (this.#activeStep == 0) {
			formWrapper.hide();
			//cardRating.hide();
		} else {
			previousWrapper.show( 'active' );
			currentWrapper.show( 'active' );
		}
	}

	#closeAllSteps() {
		const card = this.#wrapper.child('.cmp-rating__card-second');
		const form = this.#wrapper.child('.form-rating');
		const typeWrapper = this.#wrapper.child(".cmp-steps-rating".concat(this.#typeRating));
		card.hide();
		form.hide();
		typeWrapper.hide();
	}
	#closePreviousStep() {
		const stepWrapper = this.#wrapper.child('[data-step].active');
		if ( stepWrapper ) {
			stepWrapper.hide( 'active' );
		}
	}

	#postValutazione() {
		this.#spinner.show();

		var object = {};
		object.page = this.#valutazione.get('page');
		object.rating = this.#wrapper.child('input[name="ratingStar"]:checked').value;
		object.answer = this.#wrapper.child('input[name="answer"]:checked').value;
		object.altro = this.#wrapper.child('input[name="altro"]').value;
		object.domanda = this.#wrapper.child('input[name="domanda"]').value;
		const json = JSON.stringify(object);

		const url = this.#valutazione.get('urlPageRating');

		fetch(	url, {
			method: 'put',
			mode: 'same-origin',
			cache: 'no-cache',
			credentials: 'include',
			body: json,
			headers: {
				'Content-Type': 'application/json'
			}
		}).then( (response) => {
			this.#spinner.hide();
			if ( !response.ok ) {
				alert( response.statusText );
			}
		}).catch( (error) => {
			this.#spinner.hide();
			alert( error );
		});
	}
}

export default KibernetesValutazioni
